import React, { Component } from 'react';
import { Box } from '@mui/material';
import { bool, array, object, shape, func } from 'prop-types';
import Autocomplete from 'components/controls/AutocompleteField';
import { I18n } from 'utils/i18n';
import connector from './connector';
import SelectTitle from '../SelectTitle';

class TimeZone extends Component {
  // eslint-disable-next-line @eslint-react/no-component-will-mount -- legacy lifecycle; loads time zones once on mount
  componentWillMount() {
    const {
      actions,
      timeZones: { timeZones },
    } = this.props;

    if (!Array.isArray(timeZones) || !timeZones.length) {
      actions.config.timeZones.loadTimeZones();
    }
  }

  generateTimeZoneLabel = option => `${option.gmt} ${option.zone}`;

  findTimeZoneValue = (options, value) => options.find(option => option.zone === value);

  render() {
    const {
      timeZones: { timeZones, loading },
      settings,
      onChange,
    } = this.props;
    const { timeZone } = settings || {};
    const zones = Array.isArray(timeZones) ? timeZones : [];

    return (
      <Box sx={{ pr: '20px' }}>
        <SelectTitle headline={I18n.t('SettingsDrawer.Time zone')} />
        <Autocomplete
          autoWidth
          placeholder={
            loading
              ? I18n.t('SettingsDrawer.Loading time zones')
              : I18n.t('SettingsDrawer.Choose time zone')
          }
          options={zones.map(option => ({
            ...option,
            label: this.generateTimeZoneLabel(option),
            value: option.zone,
          }))}
          value={timeZone}
          onChange={onChange}
          labelGenerator={this.generateTimeZoneLabel}
          findValue={this.findTimeZoneValue}
        />
      </Box>
    );
  }
}

TimeZone.propTypes = {
  actions: object.isRequired,
  timeZones: shape({
    timeZones: array,
    loading: bool,
  }).isRequired,
  settings: object,
  onChange: func.isRequired,
};

TimeZone.defaultProps = {};

export default connector(TimeZone);
